$( ".main-titol.b" ).wrapInner( "<div></div>");
$("nav:first .nav-item > a").on("click", function (e) {
  const parentItem = $(this).closest(".nav-item");

  if (parentItem.find(".sub-nav").length === 0) {
    window.location = $(this).attr("href");
  }
});
$("nav:first").accessibleMegaMenu({
    /* prefix for generated unique id attributes, which are required
       to indicate aria-owns, aria-controls and aria-labelledby */
    uuidPrefix: "accessible-megamenu",

    /* css class used to define the megamenu styling */
    menuClass: "nav-menu",

    /* css class for a top-level navigation item in the megamenu */
    topNavItemClass: "nav-item",

    /* css class for a megamenu panel */
    panelClass: "sub-nav",

    /* css class for a group of items within a megamenu panel */
    panelGroupClass: "sub-nav-group",

    /* css class for the hover state */
    hoverClass: "hover",

    /* css class for the focus state */
    focusClass: "focus",

    /* css class for the open state */
    openClass: "open"
});
$(".section-nav:first").accessibleMegaMenu({
    uuidPrefix: "section-accessible-megamenu",
    menuClass: "nav-menu",
    topNavItemClass: "nav-item",
    panelClass: "sub-nav",
    panelGroupClass: "sub-nav-group",
    hoverClass: "hover",
    focusClass: "focus",
    openClass: "open"
});


// text accessible dels botons per tornar enrere als menús lliscants
var etiquetaEnrere = {ca: 'Enrere', es: 'Atrás', en: 'Back'}[document.documentElement.lang] || 'Enrere';

$(".mobile_menu").simpleMobileMenu({
  "backLabel" : etiquetaEnrere,
  //Hamburger Id
  "hamburgerId" : "menu-mobil-toogle",
  //Menu Wrapper Class
  "wrapperClass" : "menu-mobil",
  //Submenu Class
  "submenuClass" : "submenu",
  //Menu Style
  "menuStyle" : "slide",
  // Callback - Menu loaded
  "onMenuLoad" : function(menu) {
    alturaInicial = menu.outerHeight();
    menu.attr("data-altura-inicial", alturaInicial);
      console.log("menu loaded")
      console.log(alturaInicial)
      console.log(menu)
    },
    //Callback - menu toggle(open/close)
    "onMenuToggle" : function(menu,open) {
      const submenu = menu.find("li.active").last().closest("ul.submenu");
      const mobileMenuHeight = submenu.outerHeight();
      if (open) {
        $(".mobile_menu").css("height", mobileMenuHeight + "px");
      }
      if (!open) {
        $(".mobile_menu").css(
          "height",
          $(".mobile_menu").data("altura-inicial") + "px"
        );
      }
      console.log(mobileMenuHeight);
      console.log(open)
    }
  });

  // Els handlers externs ".hasChild > a, .submenu-open" i ".back" per ajustar l'alçada
  // del .mobile_menu es van treure (igual que es va fer a web2025 el 2026-10-19) perquè
  // mesuraven l'alçada del submenu abans que jquery-simple-mobilemenu.js completés la
  // transició. Ara l'alçada la gestiona íntegrament el callback onMenuToggle d'aquesta
  // mateixa crida a simpleMobileMenu() (a sobre), que ja fa la mesura al moment correcte.

  $(function() {

    $('#menu-secundari-toogle').on('click', function() {

      $('.submenu-secundari-mobil').toggleClass('is-open');

      let expanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !expanded);

    });

  });

$(".menu_lateral").simpleMenu({
  "backLabel" : etiquetaEnrere,
  //Menu Wrapper Class
  "wrapperClass" : "menu_lateral_wrapper",
  //Submenu Class
  "submenuClass" : "submenu",
  //Menu Style
  "menuStyle" : "slide",
  // Callback - Menu loaded
  "onMenuLoad" : function(menu) {
    alturaInicial = menu.outerHeight();
    menu.attr("data-altura-inicial", alturaInicial);
    },
    //Callback - menu toggle(open/close)
    "onMenuToggle" : function(menu,open) {
      const submenu = menu.find("li.active.hasChild").last().find("ul.submenu");
      if (typeof submenu === 'undefined' || submenu.length === 0) {
        $(".menu_lateral").css(
          "height",
          $(".menu_lateral").data("altura-inicial") + "px"
        );
        return;
      }
      const mobileMenuHeight = submenu.outerHeight();
      $(".menu_lateral").css("height", mobileMenuHeight + "px");
    }
  });

  $(document).on("click", ".hasChild > a, .submenu-open", function () {

    const menu = $(".menu-mobil");
    const submenuActiu = $(this).next(".submenu");

    if (submenuActiu.length) {
      const novaAltura = submenuActiu.outerHeight();
      $(".mobile_menu").css("height", novaAltura + "px");
    }

  });

  $(document).on("click", ".back", function () {
    $(".mobile_menu").css(
      "height",
      $(".mobile_menu").data("altura-inicial") + "px"
    );
  });




(function() {

    var time = 600,
        timer;

    function handlerIn() {
        clearTimeout(timer);
        $('.sub-nav .intro').stop(true).css('opacity', 0).hide();
    }
    function handlerOut() {
        //if($('elemFoo').css('opacity') == 0) {
            timer = setTimeout(function() {
                $('.sub-nav .intro').css('opacity', 1).fadeIn();
            }, time);

    }

    $(".sub-nav-group").hover(handlerIn, handlerOut);

}());


// Fer que el .sub-nav s'adapti a l'alçada del sub-nivell quan es desplega un contingut més llarg
// Nomes al menú desktop; al mòbil no apliquem cap min-height.
(function() {
    var mqDesktop = window.matchMedia('(min-width: 62.5625em)');

    function esDesktop() {
        return mqDesktop.matches;
    }

    function mesuraAlcadaSubNivell($subLevel) {
        // Sumem l'alçada real dels li directes del sub-nivell + padding del ul,
        // evitant pseudo-elements (:before) i descendents en absolut.
        var alcada = 0;
        $subLevel.children('li').each(function() {
            alcada += this.offsetHeight;
        });
        var cs = window.getComputedStyle($subLevel[0]);
        alcada += (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
        return alcada;
    }

    function ajustaAlcada() {
        if (!esDesktop()) return;
        var $li = $(this);
        var $subLevel = $li.children('ul.sub-level-group');
        if ($subLevel.length === 0) return;
        var $subNav = $li.closest('.sub-nav');
        if ($subNav.length === 0) return;

        var alcadaSubLevel = mesuraAlcadaSubNivell($subLevel);
        var $subNavGroup = $subNav.children('.sub-nav-group');
        var $firstUl = $subNavGroup.children('ul');
        var alcadaFirstUl = $firstUl.outerHeight(true) || 0;
        var alcadaContent = Math.max(alcadaFirstUl, alcadaSubLevel);

        // Comptem l'espai del títol, el padding del .sub-nav i afegim marge extra
        // perquè l'últim element no quedi enganxat a la part de baix.
        var subNavRect = $subNav[0].getBoundingClientRect();
        var groupRect = $subNavGroup[0].getBoundingClientRect();
        var offsetTop = groupRect.top - subNavRect.top;
        var csSubNav = window.getComputedStyle($subNav[0]);
        var paddingBottom = parseFloat(csSubNav.paddingBottom) || 0;
        var marge = 5;

        var alcadaRequerida = offsetTop + alcadaContent + paddingBottom + marge;
        $subNav.css('min-height', alcadaRequerida + 'px');
    }

    function reseteja() {
        $(this).css('min-height', '');
    }

    $(document).on('mouseenter focusin', '.sub-nav .sub-nav-group ul li', ajustaAlcada);
    $(document).on('mouseleave', '.sub-nav', reseteja);

    // Si l'usuari redimensiona i deixa de ser desktop, netegem qualsevol min-height residual
    function neteja() {
        if (!esDesktop()) {
            $('.sub-nav').css('min-height', '');
        }
    }
    if (mqDesktop.addEventListener) {
        mqDesktop.addEventListener('change', neteja);
    } else if (mqDesktop.addListener) {
        mqDesktop.addListener(neteja);
    }
}());



$( ".nav-menu a" ).on( "click", function() {
    $('.desplegable__boto').removeClass('open').attr('aria-expanded', 'false');
    $('.desplegable ul').attr('aria-hidden', 'true');

});
//si es touch prevenim click als dropdowns
if (feature.touch) {
    $( ".sub-nav a.dropdown" ).on( "click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    });
}
//prevenim click al menú principal amb submenús
$( ".nav-item a[aria-haspopup]" ).on( "click", function(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
});

$( ".sub-nav .tancar" ).on( "click", function(event) {
    event.preventDefault();
    event.stopPropagation();
    $('.nav-item a').removeClass('open focus').attr('aria-expanded', 'false');
    $('.sub-nav').removeClass('open').attr('aria-expanded', 'false');


});

/* fixed scroll */
$idioma = $('html').attr('lang');
switch($idioma) {
    case 'es':
        var textHome = 'Inicio';
        var textSearch = 'Buscar';
        break;
    case 'en':
        var textHome = 'Home';
        var textSearch = 'Search';
        break;
    default:
        var textHome = 'Inici';
        var textSearch = 'Cercar';
}
$(".menu .nav-menu").prepend('<li class="menu-fixed menu-fixed__home nav-item"><a href="'+$('#home').attr('href')+'"><img '+ homeIcon +' alt="' + textHome + '"></a></li>');
$(".menu .nav-menu").append('<li class="menu-fixed menu-fixed__search nav-item"><a href="'+$('#cercar').attr('href')+'"><img src="/media/img/ico-cerca-cap.svg" alt="' + textSearch + '"></a></li>');

$(".main-header .menu").stick_in_parent({
  parent: ".wrapper", // note: we must now manually provide the parent
  sticky_class : 'fixed',
  spacer: false
}).on("sticky_kit:stick", function(e) {
  e.target.parentNode.style['min-height'] = $(e.target).outerHeight() + 'px';
}).on("sticky_kit:unstick", function(e) {
  e.target.parentNode.style['min-height'] = 'auto';
});
$("#master-breadcrumb").stick_in_parent({
  parent: ".wrapper", // note: we must now manually provide the parent
  sticky_class : 'fixed',
  spacer: false
}).on("sticky_kit:stick", function(e) {
  e.target.parentNode.style['min-height'] = $(e.target).outerHeight() + 'px';
}).on("sticky_kit:unstick", function(e) {
  e.target.parentNode.style['min-height'] = 'auto';
});
//scroll ancores
$(function() {
  $('a[href*="#"]:not([href="#"],.tab,[role="tab"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        target = target.filter(':visible').first().length ? target.filter(':visible').first() : target.first();
        $('html, body').animate({
          scrollTop: target.offset().top-50
        }, 1000).promise().done(function() {
          // mou el focus al destí perquè el teclat i els lectors de pantalla hi continuïn
          if (!target.is('a[href], button, input, select, textarea, [tabindex]')) {
            target.attr('tabindex', '-1');
          }
          target[0].focus({preventScroll: true});
        });
        return false;
      }
    }
  });
});
$(window).scroll(function(){
    if ($(this).scrollTop() > 300) {
      $('.top').fadeIn();
    } else {
      $('.top').fadeOut();
    }
  });

/*---PORTADA
//carrusel notícies
/*----------*/
/* Carousel */
/*----------*/

// fletxes del carrusel: text traduït i desactivades de veritat quan no hi ha més diapositives
var etiquetesCarrusel = {
  ca: ['Anterior', 'Següent'],
  es: ['Anterior', 'Siguiente'],
  en: ['Previous', 'Next']
}[document.documentElement.lang] || ['Anterior', 'Següent'];
$(".carousel").on('init reInit afterChange setPosition', function() {
  var $fletxes = $(this).find('.slick-arrow');
  $fletxes.each(function() {
    var desactivar = $(this).hasClass('slick-disabled');
    if (desactivar && document.activeElement === this) {
      // el focus no es perd: passa a l'altra fletxa
      $fletxes.not(this).trigger('focus');
    }
    this.disabled = desactivar;
  });
});
$(".carousel").slick({
  dots: false,
  infinite: false,
  lazyLoad: 'ondemand',
  slidesToShow: 4,
  slidesToScroll: 3,
  prevArrow:'<button type="button" class="slick-prev slick-arrow" aria-label="' + etiquetesCarrusel[0] + '"><span aria-hidden="true">&larr;</span></button>',
  nextArrow:'<button type="button" class="slick-next slick-arrow" aria-label="' + etiquetesCarrusel[1] + '"><span aria-hidden="true">&rarr;</span></button>',
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: false,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
// On before slide change
$('.carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  console.log(nextSlide);
  if (nextSlide == 0){
    $( ".slick-list" ).removeClass( "on" );
  }else{
    $( ".slick-list" ).addClass( "on" );

  }


});
/*function initCarousel()
{
    "use strict";
    var amplada = $(window).width();
    var ampladaNoticia = 450;
    var itemsSkip = 2;
    if (amplada >= 1024){
        var ampladaNoticia = 350;
        itemsSkip = 2;
    }else if (amplada >= 700){
         var ampladaNoticia = 300;
         itemsSkip = 1;
    }

    if ($(".carousel").length)  //if it exists and hasn't been initialised
    {
        $(".carousel").each(function() {
            var thisCarousel = $(this);
            thisCarousel.carouFredSel(
            {
                responsive: true,
                auto: false,
                debug: false,
                circular: false,
                infinite: false,
                items: {
                    //start: -1,
                    //start: 1,
                    width: ampladaNoticia,
                    visible:{
                        min: 2,
                        max: 4
                    }
                },
                scroll: {
                    items: itemsSkip,
                    onBefore : function(oldItems, newItems) {
                        $(window).trigger("scroll");
                    },
                    onAfter : function(data) {
                        data.items.visible.each(function(){
                            var src = $(this).find('img').attr('src');
                            var original = $(this).find('img').data('original');
                            if (original != undefined && original != '' && original != src) {
                                $(this).find('img').attr('src', original);
                            }
                        });


                    }

                },
                prev: {
                    button: thisCarousel.closest(".carousel-wrapper").find(".carousel-prev"),
                    key: "left"
                },
                next: {
                    button: thisCarousel.closest(".carousel-wrapper").find(".carousel-next"),
                    key: "right"
                }
            });


            thisCarousel.swipe(
            {
                swipeLeft: function(event, direction, distance, duration, fingerCount) {
                    thisCarousel.trigger('next');
                },
                swipeRight: function(event, direction, distance, duration, fingerCount) {
                    thisCarousel.trigger('prev');
                },
                allowPageScroll: 'vertical',
                excludedElements: "button, input, select, textarea, .noSwipe"
            });
        });

        carouselInitialised = true;
    }
}*/
/*--------------*/
/* END Carousel */
/*--------------*/
 carouselInitialised = false;
 if ($(".carousel").length && !carouselInitialised)
        {
            //initCarousel();
        }
/*-----------------*/
/* Window Resizing */
/*-----------------*/
$(window).on("resize", function()
{

     //initCarousel();


});

/*---PORTADA slider */
if ( $( ".slider" ).length ) {
  var $slideImatges = $(".slider");

  // textos del control de pausa i de la paginació (WCAG 2.2.2: el moviment automàtic s'ha de poder aturar)
  var textosSlider = {
    ca: {aturar: 'Atura el carrusel', reprendre: 'Reprèn el carrusel', diapositiva: 'Diapositiva'},
    es: {aturar: 'Detén el carrusel', reprendre: 'Reanuda el carrusel', diapositiva: 'Diapositiva'},
    en: {aturar: 'Pause the carousel', reprendre: 'Play the carousel', diapositiva: 'Slide'}
  }[document.documentElement.lang] || {aturar: 'Atura el carrusel', reprendre: 'Reprèn el carrusel', diapositiva: 'Diapositiva'};
  // si l'usuari ha demanat menys moviment al sistema, el carrusel comença aturat
  var sliderAturat = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // només la diapositiva visible és accessible: les altres queden fora del Tab i dels lectors de pantalla
  // (carouFredSel reordena els elements i la diapositiva visible sempre és la primera)
  function marcarDiapositivaVisible() {
    $slideImatges.children().each(function(i) {
      this.inert = i > 0;
      if (i > 0) {
        this.setAttribute('aria-hidden', 'true');
      } else {
        this.removeAttribute('aria-hidden');
      }
    });
  }

  $slideImatges.carouFredSel({
     width   : "100%",
      responsive: true,
      auto        : {
          timeoutDuration : 10000,
          delay: 10000
      },
      debug: false,
      // sense "key": les fletxes del teclat no s'han de capturar a tota la pàgina
      prev: {
          button      : ".prev-btn"
      },
      next: {
          button      : ".next-btn"
      },
      pagination  : {
          container       : ".pager-wrapper",
          anchorBuilder   : function( nr ) {
              return '<button type="button"><span class="vh">' + textosSlider.diapositiva + ' ' + nr + '</span></button>';
          }
      },
      //Possible values: "none", "scroll", "directscroll", "fade", "crossfade", "cover", "cover-fade", "uncover" or "uncover-fade".
      //carouFredSel defines only 5 easing functions, “linear”, “swing”, “quadratic”, “cubic” and “elastic“.
      scroll      : {
          fx          : "crossfade",
          easing      : "linear",
          duration    : 1000,
          onAfter     : marcarDiapositivaVisible
      },
      onCreate: onCreate
  });

  // botó per aturar i reprendre el moviment automàtic, el primer element del carrusel
  var $botoPausa = $('<button type="button" class="slider-pausa"><svg class="icona-pausa" aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="16" height="16"><rect x="3" y="2" width="3.5" height="12"/><rect x="9.5" y="2" width="3.5" height="12"/></svg><svg class="icona-play" aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="16" height="16"><path d="M4 2l10 6-10 6z"/></svg></button>');
  function actualitzarBotoPausa() {
    $botoPausa.toggleClass('aturat', sliderAturat)
      .attr('aria-label', sliderAturat ? textosSlider.reprendre : textosSlider.aturar);
  }
  // el carrusel avança només si l'usuari no l'ha aturat i no hi té el ratolí ni el focus
  var $wrapperSlider = $(".slider-wrapper"), ratoliDins = false, focusDins = false;
  function aplicarEstatSlider() {
    $slideImatges.trigger(sliderAturat || ratoliDins || focusDins ? 'pause' : 'resume');
  }
  $botoPausa.on('click', function() {
    sliderAturat = !sliderAturat;
    actualitzarBotoPausa();
    aplicarEstatSlider();
  });
  $wrapperSlider.prepend($botoPausa);
  actualitzarBotoPausa();
  aplicarEstatSlider();
  $wrapperSlider.on('mouseenter', function() {
    ratoliDins = true;
    aplicarEstatSlider();
  }).on('mouseleave', function() {
    ratoliDins = false;
    aplicarEstatSlider();
  }).on('focusin', function() {
    focusDins = true;
    aplicarEstatSlider();
  }).on('focusout', function(e) {
    if (!$.contains(this, e.relatedTarget)) {
      focusDins = false;
      aplicarEstatSlider();
    }
  });

  // la diapositiva visible es marca a la paginació amb aria-current
  function marcarDiapositivaActual() {
    $(".pager-wrapper button").removeAttr('aria-current')
      .filter('.selected').attr('aria-current', 'true');
  }
  $(".pager-wrapper").each(function() {
    new MutationObserver(marcarDiapositivaActual).observe(this, {subtree: true, attributes: true, attributeFilter: ['class']});
  });
  marcarDiapositivaActual();
  marcarDiapositivaVisible();
}
// vídeo de capçalera que es reprodueix sol (urv_portada_moduls): botó per aturar-lo i reprendre'l (WCAG 2.2.2)
$('.video-container .video-pausa').each(function() {
  var $boto = $(this);
  var $contenidor = $boto.closest('.video-container');
  var textos = {
    ca: {aturar: 'Atura el vídeo', reprendre: 'Reprèn el vídeo'},
    es: {aturar: 'Detén el vídeo', reprendre: 'Reanuda el vídeo'},
    en: {aturar: 'Pause the video', reprendre: 'Play the video'}
  }[document.documentElement.lang] || {aturar: 'Atura el vídeo', reprendre: 'Reprèn el vídeo'};
  var aturat = false;
  var ordre = function(funcio) {
    // API de l'iframe de YouTube (enablejsapi=1). L'iframe es busca cada vegada perquè el gestor de galetes
    // el pot substituir; si encara no s'ha carregat, no es fa res
    var iframe = $contenidor.find('iframe')[0];
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify({event: 'command', func: funcio, args: []}), '*');
    }
  };
  var actualitzar = function() {
    $boto.toggleClass('aturat', aturat).attr('aria-label', aturat ? textos.reprendre : textos.aturar);
  };
  $boto.on('click', function() {
    aturat = !aturat;
    actualitzar();
    ordre(aturat ? 'pauseVideo' : 'playVideo');
  });
  // si l'usuari ha demanat menys moviment al sistema, el vídeo s'atura en carregar-se
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    aturat = true;
    $contenidor.on('load', 'iframe', function() {
      setTimeout(function() { ordre('pauseVideo'); }, 500);
    });
    $contenidor.find('iframe').on('load', function() {
      setTimeout(function() { ordre('pauseVideo'); }, 500);
    });
  }
  actualitzar();
  $boto.prop('hidden', false);
});
function onCreate() {
  $(window).on('resize', onResize).trigger('resize');
  $(".slider-wrapper").css("opacity","1");
}

function onResize() {
  // Get all the possible height values from the slides
  var heights = $slideImatges.children().map(function() { return $(this).height(); });
  // Find the max height and set it
  $slideImatges.parent().add($slideImatges).height(Math.max.apply(null, heights));
}


  /*------------------*/
  /* Lazy load images */
  /*------------------*/
  $("img.lazy:not('img.noLazy')").show().lazyload({
    effect: "fadeIn"
//      failure_limit: 2,
//      threshold: 400
//      skip_invisible: false
  });
$(function() {
    $("img.lazySlider").lazyload({
        event : "sporty"
    });
});

$(window).bind("load", function() {
    var timeout = setTimeout(function() {
        $("img.lazySlider").trigger("sporty")
    }, 100);
});

  $("img.lazyNoticies").lazyload({
    effect: "fadeIn",
    threshold: 50,
    failure_limit: 5//
  });
  /*----------------------*/
  /* END Lazy load images */
  /*----------------------*/

$(document).ready(function() {
    if($( window ).width() < 1000){
        $(".main-nav").attr("aria-hidden","true");
    }
    // elements del menú mòbil que es poden enfocar ara mateix (els submenús tancats són visibility:hidden)
    function focusablesMenuMobil() {
      return $('.menu-mobil').find('a[href], button, input, select, textarea').filter(function() {
        return this.getClientRects().length && getComputedStyle(this).visibility !== 'hidden' && !this.disabled;
      });
    }
    // menú mòbil obert: Escape el tanca i el Tab no surt del menú (la resta de la pàgina queda tapada)
    $(document).on('keydown', function(e) {
      var $boto = $('#menu-mobil-toogle');
      if (!$('.menu-mobil').hasClass('open') || (e.key !== 'Escape' && e.key !== 'Tab')) {
        return;
      }
      if (e.key === 'Escape') {
        $boto.trigger('click').trigger('focus');
        return;
      }
      var $items = focusablesMenuMobil();
      if (!$items.length) {
        return;
      }
      if (!e.shiftKey && document.activeElement === $items.last()[0]) {
        e.preventDefault();
        $boto.trigger('focus');
      } else if (e.shiftKey && document.activeElement === $boto[0]) {
        e.preventDefault();
        $items.last().trigger('focus');
      }
    });
    $( ".main-nav__button" ).on( "click", function() {
      var atribut = $('.menu-mobil').attr('aria-hidden');

      if(atribut == "true"){
        $(".menu-mobil").attr("aria-hidden","false").addClass("open");
        $(this).attr("aria-expanded","true").addClass("open").addClass("close");
      }else{
        $(".menu-mobil").attr("aria-hidden","true").removeClass("open");
        $(this).attr("aria-expanded","false").removeClass("open").removeClass("close");
      }
    });
    $( window ).resize(function() {
        if($( window ).width() > 1000){
            $(".menu-mobil").attr("aria-hidden","false").removeClass("open");
            $(".main-nav__button").attr("aria-expanded","false").removeClass("close").removeClass("open");
            $(".search-mobile").removeClass("open");
        }
    });

    $('.main-header .menu').addClass("load");

    $( ".tancar__alerta" ).on( "click", function() {
        $('#portada-alerta').hide();
    });
    var $obridorCercador = $();
    function tancarCercador() {
        $( ".cercadorDesplegable" ).slideUp( "slow" );
        // retorna el focus a l'enllaç que ha obert el cercador
        $obridorCercador.trigger('focus');
        $obridorCercador = $();
    }
    $( "#cercar,.menu-fixed__search a,a.cercar-mobile" ).on( "click", function() {
        $obridorCercador = $(this);
        $( ".cercadorDesplegable" ).slideDown( "slow", function() {
          $( "#campcercar" ).focus();
        });
        return false;
    });
    $( ".tancar__cercar" ).on( "click", tancarCercador);
    $( ".cercadorDesplegable" ).on( "keydown", function(e) {
        if (e.key === 'Escape') {
            tancarCercador();
        }
    });
    //taula masters
     $( ".advanced-search button.more" ).on( "click", function(e) {
         $(this).hide();
         $(".advanced-search button.less").show();
         $( ".advanced-search--form" ).slideDown( "slow", function() {

        });
        return false;
    });
     $( ".advanced-search button.less" ).on( "click", function(e) {
         $(this).hide();
         $(".advanced-search button.more").show();
         $( ".advanced-search--form" ).slideUp( "slow", function() {

        });
        return false;
    });
     //entrevista
     $( ".professorat button.more" ).on( "click", function(e) {
         $(this).hide();
         $(".professorat  button.less").show();
         $( "#entrevista" ).attr('aria-hidden', 'false');
         $( "#entrevista" ).slideDown( "fast", function() {

         });
         $(".professor  button.more-perfil").show();
         $(".professor  button.less-perfil").hide();
         $( "#perfil-docent-coordinador" ).attr('aria-hidden', 'true');
         $( "#perfil-docent-coordinador" ).slideUp( "fast", function() {

          });
        return false;
    });
     $( ".professorat button.less" ).on( "click", function(e) {
         $(this).hide();
         $(".professorat  button.more").show();
         $( "#entrevista" ).attr('aria-hidden', 'true');
         $( "#entrevista" ).slideUp( "fast", function() {

          });
        return false;
    });
     $( ".professorat #perfil-docent-coordinador-more" ).on( "click", function(e) {
         $(".professorat  button.more").show();
         $(".professorat  button.less").hide();
         $( "#entrevista" ).attr('aria-hidden', 'true');
         $( "#entrevista" ).slideUp( "fast", function() {

          });
        return false;
    });
     $( ".professorat button.more-perfil" ).on( "click", function(e) {
         $(this).hide();
         var obrirperfil = $(this).attr("data-id");
         $(this).parent().find("button.less-perfil").show();
         $( "#"+obrirperfil ).attr('aria-hidden', 'false');
         $( "#"+obrirperfil ).slideDown( "fast", function() {

        });
        return false;
    });
     $( ".professorat button.less-perfil" ).on( "click", function(e) {
         $(this).hide();
         var obrirperfil = $(this).attr("data-id");
         $(this).parent().find("button.more-perfil").show();
         $( "#"+obrirperfil ).attr('aria-hidden', 'true');
         $(  "#"+obrirperfil ).slideUp( "fast", function() {

        });
        return false;
    });

    // botons mostrar/amagar (cerca avançada, entrevista, perfils): cada parell indica l'estat amb
    // aria-expanded i, com que el botó premut s'amaga, el focus passa a l'altre botó del parell
    function prepararParellMostrarAmagar($mes, $menys, $panell) {
      if (!$mes.length || !$menys.length || !$panell.length) {
        return;
      }
      if (!$panell.attr('id')) {
        $panell.attr('id', 'panell-desplegable-' + Math.random().toString(36).slice(2, 8));
      }
      $mes.attr({type: 'button', 'aria-expanded': 'false', 'aria-controls': $panell.attr('id')});
      $menys.attr({type: 'button', 'aria-expanded': 'true', 'aria-controls': $panell.attr('id')});
      $mes.add($menys).find('svg').attr({'aria-hidden': 'true', focusable: 'false'});
      $mes.on('click', function() {
        setTimeout(function() { $menys.trigger('focus'); }, 0);
      });
      $menys.on('click', function() {
        setTimeout(function() { $mes.trigger('focus'); }, 0);
      });
    }
    prepararParellMostrarAmagar($('.advanced-search button.more'), $('.advanced-search button.less'), $('.advanced-search--form'));
    prepararParellMostrarAmagar($('.professorat button.more'), $('.professorat button.less'), $('#entrevista'));
    $('.professorat button.more-perfil').each(function() {
      var id = $(this).attr('data-id');
      prepararParellMostrarAmagar($(this), $(this).parent().find('button.less-perfil[data-id="' + id + '"]'), $('#' + id));
    });
    /*if ($("table.ordenar").length){
        $('.ordenar').DataTable(
        {
            autoWidth: false,
            paging: false,
            info: false,
            language: {
                search: "Filtrar per paraula/es",
                sZeroRecords:  "No s'han trobat màsters.",
            }
        });
    }*/
    $( ".botons-accio a" ).wrapInner( "<span></span>" );
    $( ".section-nav a.external,.section-nav a.privat" ).append( "<span></span>" );
    //cercador ensenyaments portada
    // filtres en viu (List.js): anuncien el nombre de resultats a una regió d'estat (WCAG 4.1.3)
    var textosFiltre = {
      ca: {un: '1 resultat', molts: '%d resultats', capEstudi: "No s'han trobat estudis, assegureu-vos que heu escrit correctament totes les paraules.", capLloc: "No s'han trobat localitzacions, assegureu-vos que heu escrit correctament totes les paraules."},
      es: {un: '1 resultado', molts: '%d resultados', capEstudi: 'No se han encontrado estudios, aseguraos de que habéis escrito correctamente todas las palabras.', capLloc: 'No se han encontrado localizaciones, aseguraos de que habéis escrito correctamente todas las palabras.'},
      en: {un: '1 result', molts: '%d results', capEstudi: 'No courses found. Please check that you have typed all the words correctly.', capLloc: 'No locations found. Please check that you have typed all the words correctly.'}
    }[document.documentElement.lang] || null;
    textosFiltre = textosFiltre || {un: '1 resultat', molts: '%d resultats', capEstudi: "No s'han trobat estudis, assegureu-vos que heu escrit correctament totes les paraules.", capLloc: "No s'han trobat localitzacions, assegureu-vos que heu escrit correctament totes les paraules."};
    var filtreAmbAvis = function(idContenidor, textCap) {
      var userList = new List(idContenidor, {valueNames: ['titol']});
      var noItems = $('<li id="no-items-found"></li>').text(textCap);
      var $estat = $('<p class="vh" role="status"></p>');
      $('#' + idContenidor + ' input.search').first().closest('div').append($estat);
      var temporitzador;
      userList.on('updated', function(list) {
        var n = list.matchingItems.length;
        if (n == 0) {
          $(list.list).append(noItems);
        } else {
          noItems.detach();
        }
        // s'anuncia quan l'usuari deixa d'escriure, no a cada tecla
        clearTimeout(temporitzador);
        temporitzador = setTimeout(function() {
          $estat.text(n == 0 ? textCap : (n == 1 ? textosFiltre.un : textosFiltre.molts.replace('%d', n)));
        }, 600);
      });
    };
    if ($("#estudis-filtre").length){
      $( "#estudis-filtre ul" ).addClass( "list" );
      $( "#estudis-filtre a" ).addClass( "titol" );
      filtreAmbAvis('estudis-filtre', textosFiltre.capEstudi);
    }
    //cercador localitzacions portada
    if ($("#localitzacions-filtre").length){
      $( "#localitzacions-filtre ul" ).addClass( "list" );
      $( "#localitzacions-filtre a" ).addClass( "titol" );
      filtreAmbAvis('localitzacions-filtre', textosFiltre.capLloc);
    }






        //http://heydonworks.com/practical_aria_examples/
/* 3. Progressive collapsibles
-----------------------------------------------------------------------------------------
*/

$('.collapsible h3.titol').each(function(i) {

  var $this = $(this);

  // create unique id for a11y relationship (comptador global: hi pot haver diversos mòduls a la pàgina)

  var id = 'collapsible-' + i;

  // wrap the content and make it focusable

  $this.nextUntil('h3.titol').wrapAll('<div id="'+ id +'" aria-hidden="true">');
  var panel = $this.next();

  // Add the button inside the <h2> so both the heading and button semanics are read

  $this.wrapInner('<button aria-expanded="false" aria-controls="'+ id +'">');
  var button = $this.children('button');

  // Toggle the state properties

  button.on('click', function() {
    var state = $(this).attr('aria-expanded') === 'false' ? true : false;
    $(this).attr('aria-expanded', state);
    panel.attr('aria-hidden', !state);
    if($(this).hasClass('open')){
         $(this).removeClass('open');

      }else{
        $(this).addClass('open');

      }
  });

});
//http://heydonworks.com/practical_aria_examples/
/* 9. Simple dropdowns
-----------------------------------------------------------------------------------------
*/
    // desplegables de la capçalera (Dreceres, Informació per a..., idioma): patró de botó desplegable,
    // amb aria-expanded i tancament amb Escape (el focus torna al botó)
    $('.desplegable > a[aria-haspopup], .desplegable > a.desplegable__boto').each(function(i) {
      var $llista = $(this).next('ul');
      if (!$llista.attr('id')) {
        $llista.attr('id', 'desplegable-' + i);
      }
      $(this).addClass('desplegable__boto').removeAttr('aria-haspopup')
        .attr({role: 'button', 'aria-expanded': 'false', 'aria-controls': $llista.attr('id')});
    });

    var showSubmenu = function($boto) {
      $boto.addClass('open').attr('aria-expanded', 'true').next('ul').attr('aria-hidden', 'false');
    };

    var hideSubmenu = function($boto) {
      $boto.removeClass('open').attr('aria-expanded', 'false').next('ul').attr('aria-hidden', 'true');
    };

    var hideAllSubmenus = function() {
      $('.desplegable__boto.open').each(function() {
        hideSubmenu($(this));
      });
    };

    $(document).click(function(e) {
        if (!$(e.target).is('.desplegable, .desplegable *')) {
            hideAllSubmenus();
        }
    });
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
        var $obert = $('.desplegable__boto.open');
        if ($obert.length) {
          var tornarFocus = $.contains($obert.parent()[0], document.activeElement);
          hideAllSubmenus();
          if (tornarFocus) {
            $obert.first().trigger('focus');
          }
        }
      }
    });
    $('.desplegable__boto').on('click', function(e) {
      var $boto = $(this), obert = $boto.hasClass('open');
      hideAllSubmenus();
      if (!obert) {
        showSubmenu($boto);
      }
      e.stopPropagation();
      return false;
    }).on('keydown', function(e) {
      // role="button": l'espai també l'activa
      if (e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });


});
